export enum DatabaseItemLayoutType {
  Card = 'card',
  FullScreen = 'fullScreen',
  Sidebar = 'sidebar',
}
